import * as React from 'react';
import clsx from 'clsx';
import { Typography } from '@/components/common';
import { CasePillProps } from '@/interfaces';

export const CasePill: React.FC<CasePillProps> = ({
	tone,
	children,
	className,
}) => {
	return (
		<Typography
			type="semibold-12"
			className={clsx(
				'inline-flex w-fit shrink-0 items-center whitespace-nowrap rounded-full px-3 py-1',
				{
					'bg-[#FFF0F4] !text-[#D9003A]': tone === 'danger',
					'bg-gray-10 text-gray-35': tone === 'neutral',
					'bg-[#EAF4FD] !text-main-blue': tone === 'info',
				},
				className
			)}
		>
			{children}
		</Typography>
	);
};
